import { ResponseWithError } from '../models/app';
import { getAPIClient } from '@/lib/api';

export const signup = async ({
  first_name,
  last_name,
  email,
  password,
  newsletter,
  privacy,
  lang,
  country
}: {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  newsletter: boolean;
  privacy: boolean;
  lang: string;
  country: string;
}): Promise<ResponseWithError> => {
  const apiClient = getAPIClient({ country });

  try {
    const response = await apiClient.post(
      '/wp-json/uyn/v1/user/signup',
      {
        firstname: first_name,
        lastname: last_name,
        email,
        password,
        nflag: newsletter,
        pflag: privacy
      },
      {
        headers: { ['UYN-LANGUAGE']: lang, ['UYN-COUNTRY']: country }
      }
    );

    return response;
  } catch (error) {
    return { error };
  }
};

export const confirm = async ({
  email,
  activation_key,
  lang,
  country
}: {
  email: string;
  activation_key: string;
  lang: string;
  country: string;
}): Promise<ResponseWithError> => {
  const apiClient = getAPIClient({ country });

  const body = new FormData();

  body.append('email', email);
  body.append('activation_key', activation_key);

  try {
    const response = await apiClient.post(
      '/wp-json/uyn/v1/user/email-verification',
      body,
      {
        headers: { ['UYN-LANGUAGE']: lang, ['UYN-COUNTRY']: country }
      }
    );

    return response;
  } catch (error) {
    return { error };
  }
};
